// Customer segments, as the backend's CustomerSegments defines them. The same
// ids are sent as `segment` on a push message and in the segment-customers URL.
export const HEALTH_SEGMENTS = ["active", "cooling", "at_risk", "lost", "never"];
export const PUSH_SEGMENTS = [...HEALTH_SEGMENTS, "expiring_30d"];

export const SEGMENT_COLORS = {
  active: "#4F46E5",
  cooling: "#A5B4FC",
  at_risk: "#EA580C",
  lost: "#9CA3AF",
  never: "#E5E7EB",
};

// Translation key for a segment's display name (shared by the dashboard and
// the Marketing form/table).
export const segmentLabelKey = (segment) => `dashboard.segments.${segment}.label`;

export const segmentCustomersQueryKey = (storeId, segment, page = 1, passId = null) => [
  "dashboard",
  "segment-customers",
  storeId,
  segment,
  page,
  passId,
];
